import React, {memo, useEffect, useState} from 'react';

import {CalendarsPanelId} from '../../../libs/shared/core/src/store/panels/panelStateBase';
import {AppFrame} from '../../../libs/shared/ui/src/components/appFrame/appFrame';
import {RenderTypesEnum} from '../../../libs/shared/ui/src/components/performanceMetrics/renderProfilerContext';
import {RenderProfiler} from '../../../srcCommon/services/performanceMetrics/renderProfiler';
import {TabLargeCalendarsContainer} from './tabLargeCalendarsContainer';

/*
 * Props.
 */

interface CalendarsFrameProps {
  panelId: CalendarsPanelId;
  isVisible: boolean;
}

/*
 * Component.
 */

export const CalendarsFrame = memo<CalendarsFrameProps>((props) => {
  const {panelId, isVisible} = props;
  const [hasVisited, setHasVisited] = useState(false);

  // Only render the calendar grid once the user has visited the route once.
  useEffect(() => {
    if (isVisible && !hasVisited) {
      setHasVisited(true);
    }
  }, [hasVisited, isVisible]);

  if (!isVisible && !hasVisited) {
    return null;
  }

  return (
    <AppFrame isVisible={isVisible}>
      <RenderProfiler type={RenderTypesEnum.CALENDAR}>
        <TabLargeCalendarsContainer panelId={panelId} />
      </RenderProfiler>
    </AppFrame>
  );
});
